var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLimited)?_c('v-alert',{attrs:{"dense":"","color":"warning","dark":""}},[_vm._v(_vm._s(_vm.note))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }